import {QueryHookOptions, useQuery} from '@apollo/client';
import {GET_ACCOUNT_REVIEWS} from '../components/AccountOverview/accountOverviewQueries';
import {useAccountContext} from '../contexts/AccountContext';
import {AccountReviews, AccountReviewsVariables} from '../schema-types/AccountReviews';
import {getEnvironment} from '../utils/envTest';

export const useAccountReviews = (
  props?: QueryHookOptions<AccountReviews, AccountReviewsVariables>
) => {
  const {account, accountLoading, accountError} = useAccountContext();
  const {
    loading: accountReviewsLoading,
    error: accountReviewsError,
    data: accountReviews,
    refetch: refetchAccountReviews,
  } = useQuery<AccountReviews, AccountReviewsVariables>(GET_ACCOUNT_REVIEWS, {
    variables: {
      accountId: account?.id || '',
      idType: 'id',
      onlyCurrent: props?.variables?.onlyCurrent || false,
      curoSync: getEnvironment() === 'DEV',
    },
    skip: !account?.id,
    nextFetchPolicy: 'no-cache',
    refetchWritePolicy: 'overwrite',
    ...props,
  });
  return {
    accountReviewsLoading,
    accountReviewsError,
    accountReviews,
    refetchAccountReviews,
  };
};
